import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLeftCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM6.58579 12L11 7.58579L12.4142 9L10.4142 11H17V13H10.4142L12.4142 15L11 16.4142L6.58579 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftCircle;
